import { IIAAgentRepository, AIAgentEntity, ResponseValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class AIAgentRepository implements IIAAgentRepository {
  private readonly endpoint = '/ai/agents';

  async getAll(): Promise<ResponseValueObject<AIAgentEntity[]>> {
    const response = await axiosClient.get<ResponseValueObject<AIAgentEntity[]>>(`${this.endpoint}`);
    return response.data;
  }
}
